import React from 'react'

function PricingL3He() {
  return (
    <>
      <section className="pb-0" dir="rtl">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <div className="mb-5">
                <h2><span className="font-w-4 d-block">פיתוח, אבטחה ותשתיות — תחת מנוי חודשי אחד</span></h2>
                <p className="lead mb-2">DevSecOps ONE הוא מנוי חודשי שמעניק לכם מהנדס DevSecOps ייעודי לפי דרישה. אתם יכולים להוסיף לתור בקשות ללא הגבלה<sup className="pricing-asterisk">*</sup> בתחומי פיתוח, אבטחה ותפעול, ואנחנו מקדמים אותן בצורה מסודרת — משימה פעילה אחת בכל פעם, בהתאם לסדר העדיפויות שנקבע יחד. אתם תמיד שומרים על 100% בעלות על כל הקוד והתצורות שאנו מייצרים, כאשר הכול מתועד ומוכן למסירה פשוטה ונוחה.</p>
                <p className="pricing-intro-note mb-0">*ביצוע הבקשות בפועל כפוף למכסת השעות החודשית שנקבעה במסלול ובהסכם ההתקשרות.</p>

              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="position-relative bg-light pt-0 z-index-1" dir="rtl">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-12 col-lg-8 col-md-10 z-index-1">
              <div className="row justify-content-center">
                <div className="col-12">
                  {/* TechOps ONE Card */}
                  <div className="card border-0 shadow-lg" style={{ backgroundColor: "#f8f9fa" }}>
                    <div className="card-body py-5 px-5 text-center">
                      {/* Badge */}
                      <div className="mb-4">
                        <span className="h3 text-uppercase text-primary font-weight-bold">DevSecOps ONE</span>
                        <p className="text-muted mb-2">מנוי חודשי</p>
                        <p className="mb-0" style={{ fontSize: '1.1rem', fontWeight: '500', color: '#495057' }}>
                          <i className="las la-user-tie me-2" style={{ color: '#007bff' }}></i>
                          מפתח DevSecOps לפי דרישה
                        </p>
                      </div>

                      {/* Price */}
                      <div className="d-flex justify-content-center align-items-center border-bottom border-light pb-4 mb-4">
                        <span className="text-muted h4 mb-0 mt-2">₪</span>
                        <span className="price display-2 font-w-6 text-primary mx-2">18,900</span>
                        <span className="text-muted h4 align-self-end mb-1">/ חודש + מע"מ</span>
                      </div>

                      {/* Subtitle */}
                      <p className="text-muted mb-3">בקשות ללא הגבלה<sup className="pricing-asterisk">*</sup> • משימה פעילה אחת בכל רגע • תגובה ראשונית מהירה בשעות הפעילות • אפשרות להשהיה או ביטול בכל עת בהודעה מוקדמת של 90 יום</p>
                      <p className="pricing-plan-note" dir="rtl">
                        *ניתן להוסיף בקשות ללא הגבלה לתור. ביצוע הבקשות בפועל נעשה במסגרת מכסת השעות החודשית שנקבעה במסלול ובהסכם ההתקשרות, ועל בסיס משימה פעילה אחת בכל פעם.
                      </p>

                      <div className="text-muted mb-4">
                        <p className="mb-2">
                          <strong>בקשות ללא הגבלה בתור<sup className="pricing-asterisk">*</sup>:</strong> הוסיפו כמה בקשות שתרצו — אנחנו מקדמים משימה אחת בכל פעם, לפי סדר העדיפויות ובמסגרת מכסת השעות החודשית.
                        </p>
                        <p className="mb-2">
                          <strong>תמחור צפוי:</strong> מחיר קבוע. ללא חיוב שעתי וללא הפתעות.
                        </p>
                        <p className="mb-2">
                          <strong>מענה והתקדמות:</strong> תגובה ראשונית בשעות הפעילות, ועבודה בקצב ברור וצפוי.
                        </p>
                        <p className="mb-0">
                          <strong>עבודה גמישה:</strong> בקשות גדולות מתוחמות ומפוצלות לשלבים, כדי לשמור על קצב עבודה ברור ואיכותי.
                        </p>
                      </div>


                      {/* Why DevSecOps ONE */}
                      <div className="mb-5">
                        <h4 className="mb-4 text-center fw-bold">נבנה מהר? עכשיו מאבטחים ומגדילים נכון</h4>
                        <p className="text-muted mb-4 text-center"> מומחיות DevOps ואבטחה בשלב מוקדם יכולה להציל את המוצר שלכם מזמני השבתה ומפריצות.</p>

                        <div className="row">
                          <div className="col-lg-6 mb-4">
                            <div className="card h-100 border-0 shadow-sm">
                              <div className="card-body p-4">
                                <h6 className="fw-bold text-primary mb-3">
                                  <i className="las me-2"></i>
                                  לבנות צוות פנימי זה קשה
                                </h6>
                                <p className="text-muted small mb-0">ללא ידע בהנדסת תוכנה, שליטה בתשתיות ענן, קונטיינרים, CI/CD, אבטחה וניטור — זה מאתגר מאוד. DevSecOps ONE מעניק לכם צוות מאחורי הקלעים — מומחיות רחבה דרך נקודת קשר אחת.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6 mb-4">
                            <div className="card h-100 border-0 shadow-sm">
                              <div className="card-body p-4">
                                <h6 className="fw-bold text-primary mb-3">
                                  <i className="las me-2"></i>
                                  גיוס יקר ואיטי
                                </h6>
                                <p className="text-muted small mb-0">מהנדס DevOps עם כישורי אבטחה יכול לעלות 350K–550K+ בשנה, ולוקח חודשים לגייס. ב-18,900 לחודש, DevSecOps ONE הוא שבריר מהעלות ויכול להתחיל בתוך ימים, לא חודשים.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6 mb-4">
                            <div className="card h-100 border-0 shadow-sm">
                              <div className="card-body p-4">
                                <h6 className="fw-bold text-primary mb-3">
                                  <i className="las me-2"></i>
                                  יועצים מצטברים לעלות גבוהה
                                </h6>
                                <p className="text-muted small mb-0">יועצי DevOps ואבטחה לפי שעה גובים 450–650 ₪ לשעה. המנוי שלנו מעניק מסגרת חודשית קבועה, תור בקשות ללא הגבלה ורציפות מקצועית לאורך החודש — בכפוף למכסת השעות שנקבעה במסלול ובהסכם ההתקשרות.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6 mb-4">
                            <div className="card h-100 border-0 shadow-sm">
                              <div className="card-body p-4">
                                <h6 className="fw-bold text-primary mb-3">
                                  <i className="las me-2"></i>
                                  זזתם מהר, עכשיו מייצבים
                                </h6>
                                <p className="text-muted small mb-0">שחררתם פיצ'רים במהירות; עכשיו התשתית והאבטחה צריכים להדביק את הקצב. אנחנו מטפלים בסקיילינג, בהקשחה (Hardening) ובאוטומציה של הפלטפורמה שלכם כדי שתמשיכו לשחרר גרסאות בביטחון.</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="text-center mt-4">

                        </div>
                      </div>

                      {/* What's included */}
                      <div className="mb-5">
                        <h5 className="text-right mb-4">מה כלול</h5>

                        <div className="row text-right">
                          <div className="col-md-6 mb-4">
                            <div className="d-flex align-items-start">
                              <div className="me-3">
                                <i className="las la-lightbulb text-primary" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div className="text-right">
                                <h6 className="mb-2">תכנון ומחקר</h6>
                                <p className="text-muted small mb-0">אנו משתפים פעולה איתכם בתכנון ומחקר הרעיונות שלכם, תוך הבטחת תהליך אסטרטגי ומקצועי.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 mb-4">
                            <div className="d-flex align-items-start">
                              <div className="me-3">
                                <i className="las la-code text-primary" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div className="text-right">
                                <h6 className="mb-2">פיתוח</h6>
                                <p className="text-muted small mb-0">אנו מתמחים בהפיכת הרעיונות שלכם למציאות דיגיטלית באמצעות טכנולוגיות מתקדמות ומוכחות.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 mb-4">
                            <div className="d-flex align-items-start">
                              <div className="me-3">
                                <i className="las la-cogs text-primary" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div className="text-right">
                                <h6 className="mb-2">תשתיות</h6>
                                <p className="text-muted small mb-0">אנו מנהלים את המורכבות התפעולית ומבטיחים יכולת הרחבה וצמיחה של הפתרון שלכם.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 mb-4">
                            <div className="d-flex align-items-start">
                              <div className="me-3">
                                <i className="las la-plug text-primary" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div className="text-right">
                                <h6 className="mb-2">אינטגרציות</h6>
                                <p className="text-muted small mb-0">אנו מבצעים שילוב חלק ויעיל של מערכות מגוונות כדי ליצור סינרגיה מקסימלית בתפעול שלכם.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 mb-4">
                            <div className="d-flex align-items-start">
                              <div className="me-3">
                                <i className="las la-shield-alt text-primary" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div className="text-right">
                                <h6 className="mb-2">סייבר</h6>
                                <p className="text-muted small mb-0">אבטחת מידע היא בראש סדר העדיפויות שלנו - אנו מתכננים כל פתרון עם שכבות הגנה מתקדמות.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 mb-4">
                            <div className="d-flex align-items-start">
                              <div className="me-3">
                                <i className="las la-headset text-primary" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div className="text-right">
                                <h6 className="mb-2">ייעוץ ותמיכה</h6>
                                <p className="text-muted small mb-0">אנו מספקים ייעוץ מקצועי ותמיכה רציפה כשותף אמין לטווח הארוך.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Fair Use Scope & Exclusions */}
                      <div className="mb-5">
                        <h5 className="mb-4 fw-bold text-dark">היקף שימוש הוגן וגבולות השירות</h5>

                        {/* Fair Use Scope */}
                        <div className="card border-0 shadow-sm mb-4">
                          <div className="card-body p-4">
                            <h6 className="fw-bold text-primary mb-3">
                              <i className="las me-2"></i>
                              היקף שימוש הוגן
                            </h6>
                            <p className="text-muted mb-3">
                              DevSecOps ONE פועל במודל בקשות ללא הגבלה בגבולות סבירים. המשמעות: תוכלו לבקש כל דבר בתחום ה-DevSecOps, בתדירות הנדרשת, כל עוד המשימות מוגדרות כך שיבוצעו אחת בכל פעם.
                            </p>
                            <p className="text-muted mb-3">
                              פרויקטים גדולים במיוחד או בנייה מחדש מהותית של מוצר עשויים להתפצל למספר בקשות עוקבות כדי לאפשר ניהול תקין. (ראו את מערכת נקודות המורכבות בתנאים שלנו בהמשך, כדי להבין כיצד אנו מודדים גודל ומאמץ.) נעדכן אתכם אם בקשה רחבה מדי ונעזור לפרק אותה לשלבים איטרטיביים.
                            </p>
                            <p className="text-muted mb-0">
                              <strong>בקצרה:</strong> אתם מקבלים גמישות והיקף עבודה, ואנחנו מבטיחים הוגנות באמצעות התמקדות במשימה אחת בכל פעם, כדי לשמור על איכות וצפיות.
                            </p>
                          </div>
                        </div>

                        {/* Exclusions */}
                        <div className="card border-0 shadow-sm">
                          <div className="card-body p-4">
                            <h6 className="fw-bold text-primary mb-3">
                              <i className="las la-exclamation-circle me-2"></i>
                              חריגים
                            </h6>
                            <p className="text-muted mb-3">כדי לייצר ציפיות ברורות, הנה מה שלא כלול במנוי DevSecOps ONE:</p>

                            <div className="row g-4">
                              <div className="col-12">
                                <div className="card border-0 bg-light">
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-start">
                                      <i className="las la-code text-primary me-3 mt-1" style={{ fontSize: '1.2rem' }}></i>
                                      <div className="flex-grow-1">
                                        <h6 className="fw-semibold mb-3">היקף פיתוח אפליקציה ו-QA</h6>
                                        <p className="text-muted small mb-2">
                                          פעילויות פיתוח אפליקציה ו-QA במסגרת מנוי זה ניתנות באופן מצטבר ומבוסס-משימות, בכפוף לגבולות סבירים של היקף ומאמץ. יוזמות פיתוח מפורקות ליחידות עבודה ניתנות לניהול ומסופקות בהדרגה, עם אבני דרך ברורות ותוצרים שוטפים עד להשלמה.
                                        </p>
                                        <p className="text-muted small mb-2">
                                          כאשר מתאים, משימות פיתוח עשויות להשתלב בתהליך CI/CD, כך שכל מסירה תיבנה, תיבדק ותוצג בשקיפות ללקוח.
                                        </p>
                                        <p className="text-muted small mb-0">
                                          פיתוח מוצר מקצה לקצה בהיקף גדול, QA ידני נרחב, או עבודה הדורשת מאמץ רציף ומרוכז מעבר לקצב המנוי — עשויים לדרוש אפיון נוסף או התקשרות נפרדת.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="card border-0 bg-light h-100">
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-start">
                                      <i className="las la-headset text-primary me-3 mt-1" style={{ fontSize: '1.2rem' }}></i>
                                      <div className="flex-grow-1">
                                        <h6 className="fw-semibold mb-3">תמיכה למשתמשי קצה</h6>
                                        <p className="text-muted small mb-0">
                                          תמיכה בלקוחות שלכם או במשתמשי הקצה שלכם (למשל Helpdesk IT או תמיכת לקוחות בכוננות) אינה כלולה. אנו מתמקדים אך ורק בפיתוח (צד לקוח וצד שרת), תשתיות, אוטומציה, CI/CD ואבטחה.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="card border-0 bg-light h-100">
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-start">
                                      <i className="las la-phone text-primary me-3 mt-1" style={{ fontSize: '1.2rem' }}></i>
                                      <div className="flex-grow-1">
                                        <h6 className="fw-semibold mb-3">טיפול בתקריות בכוננות 24/7</h6>
                                        <p className="text-muted small mb-0">
                                          המנוי הבסיסי פועל בשעות עסקים. אמנם אנו מטמיעים ניטור ומגיבים להתראות, אך תגובת תקריות רציפה סביב השעון אינה כלולה כברירת מחדל. (קיים תוסף הסלמת תקריות 24/7 לצרכים קריטיים.)
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="card border-0 bg-light h-100">
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-start">
                                      <i className="las la-project-diagram text-primary me-3 mt-1" style={{ fontSize: '1.2rem' }}></i>
                                      <div className="flex-grow-1">
                                        <h6 className="fw-semibold mb-3">טכנולוגיות לגאסי שאינן נתמכות  </h6>
                                        <p className="text-muted small mb-0">
                                          אנחנו עובדים עם מגוון רחב של פלטפורמות וכלים מודרניים. עם זאת, טכנולוגיות ישנות מאוד או נישתיות עשויות להיות מחוץ למומחיות שלנו. אם כך, נציף זאת מוקדם ונציע חלופות מעשיות.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="card border-0 bg-light h-100">
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-start">
                                      <i className="las fa-history text-primary me-3 mt-1" style={{ fontSize: '1.2rem' }}></i>
                                      <div className="flex-grow-1">
                                        <h6 className="fw-semibold mb-3">פרויקטים גדולים מחוץ לקצב המנוי</h6>
                                        <p className="text-muted small mb-0">
                                          יוזמות גדולות כמו מיגרציות ענן מלאות או הסמכות תאימות מקצה לקצה עשויות לחרוג ממחזור מנוי יחיד. הן מטופלות בפיצול העבודה לבקשות מובנות או, במקרה הצורך, במסגרת התקשרות מותאמת אישית. אם ההיקף גדל מעבר לקיבולת המנוי, נדון באפשרויות מראש — ללא חיובים מפתיעים.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* How it works */}
                      <div className="mb-5">
                        <h5 className="mb-4 text-right fw-bold text-dark">איך זה עובד</h5>
                        <div className="row g-4">
                          {/* Step 1 */}
                          <div className="col-md-6 col-lg-3">
                            <div className="text-center h-100">
                              <div
                                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                  boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
                                }}
                              >
                                <i className="las la-plus text-white" style={{ fontSize: '20px' }}></i>
                              </div>
                              <h6 className="fw-semibold mb-2 text-right">שליחת בקשה</h6>
                              <p className="text-muted small mb-0 text-right">שלחו בקשות דרך הפלטפורמה שלנו, Slack או אימייל. כל משימת DevOps, תשתית, אוטומציה או אבטחה יכולה להיכנס לתור שלכם.</p>
                            </div>
                          </div>

                          {/* Step 2 */}
                          <div className="col-md-6 col-lg-3">
                            <div className="text-center h-100">
                              <div
                                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                  boxShadow: '0 4px 15px rgba(240, 147, 251, 0.3)'
                                }}
                              >
                                <i className="las la-cog text-white" style={{ fontSize: '20px' }}></i>
                              </div>
                              <h6 className="fw-semibold mb-2 text-right">עבודה ממוקדת</h6>
                              <p className="text-muted small mb-0 text-right">אנחנו בוחנים כל בקשה, מעריכים מורכבות ומפרקים פריטים גדולים לשלבים ניתנים לניהול כשצריך.</p>
                            </div>
                          </div>

                          {/* Step 3 */}
                          <div className="col-md-6 col-lg-3">
                            <div className="text-center h-100">
                              <div
                                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                                  boxShadow: '0 4px 15px rgba(79, 172, 254, 0.3)'
                                }}
                              >
                                <i className="las la-clock text-white" style={{ fontSize: '20px' }}></i>
                              </div>
                              <h6 className="fw-semibold mb-2 text-right">מסירה</h6>
                              <p className="text-muted small mb-0 text-right">בקשות שוטפות מתקדמות במהירות, ורבות מהן נמסרות בתוך 48–72 שעות עסקים. בקשות גדולות יותר מתקדמות בשלבים, עם צפי ברור ועדכונים לאורך הדרך.</p>
                            </div>
                          </div>

                          {/* Step 4 */}
                          <div className="col-md-6 col-lg-3">
                            <div className="text-center h-100">
                              <div
                                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                                  boxShadow: '0 4px 15px rgba(250, 112, 154, 0.3)'
                                }}
                              >
                                <i className="las la-sync text-white" style={{ fontSize: '20px' }}></i>
                              </div>
                              <h6 className="fw-semibold mb-2 text-right">סקירה ובקשה חדשה</h6>
                              <p className="text-muted small mb-0 text-right">אתם בודקים את העבודה שנמסרה. מסמנים את הבקשה כהושלמה — וממשיכים לבקשה הבאה בתור שלכם!</p>

                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Add-ons */}
                      <div className="mb-5">

                        <h6 className="mb-3 text-right">מסירה במסגרת שימוש הוגן</h6>
                        <p className="text-muted small text-right">DevSecOps ONE פועל בקצב מסירה צפוי ומבוסס-משימות, כאשר התפוקה משתנה לפי מורכבות. רוב הבקשות מטופלות בתוך 48–72 שעות עסקים, כאשר משימות פשוטות מסתיימות מהר יותר ועבודה מורכבת נמסרת בשלבים. העבודה מתבצעת ראשון–חמישי בשעות העסקים (למעט חגים מרכזיים), ובקשות מחוץ לשעות הפעילות נאספות ביום העסקים הבא. מאמצים ארוכים מפורקים למשימות עוקבות או נמסרים לפי טווח זמן שמוגדר ומועבר בצורה ברורה — כדי להבטיח התקדמות עקבית ושקופה ללא התחייבות לתפוקה קבועה.</p>
                      </div>

                      {/* Value Comparison */}
                      <div className="mb-5 text-center">
                        <h5 className="mb-4 fw-bold text-dark text-right">השוואת ערך</h5>

                        <div className="row justify-content-center align-items-center">
                          <div className="col-md-5 mb-3 mb-md-0 text-end">
                            <p className="mb-2"><strong>עלות צוות פנימי:</strong></p>
                            <p className="mb-1">פרונטאנד ובקאנד: 34,000–24,000 לחודש</p>
                            <p className="mb-1">DevOps / תשתיות: 36,000–28,000 לחודש</p>
                            <p className="mb-1">סייבר: 29,000–26,000 לחודש</p>
                            <hr className="my-2" />
                          </div>

                          <div className="col-md-1 text-center">
                            <span className="text-muted">vs</span>
                          </div>

                          <div className="col-md-5 text-end">
                            <p className="mb-2"><strong> DevSecOps ONE:</strong></p>
                            <p className="mb-1"><span className="h4 text-primary">18,900 / חודש</span></p>
                            <p className="mb-0 text-muted">
                              אותה מומחיות, בעלות נמוכה יותר מהעסקת מהנדס אחד
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Not included */}
                      <div className="mb-4">

                        <h6 className="text-right mb-3">תוספים להרחבת המנוי</h6>
                        <p className="text-muted small text-right">תמיכה בכוננות 24/7 • בקשות נוספות בתור בו-זמנית</p>
                      </div>


                      {/* Not included */}
                      <div className="mb-4">
                        <h6 className="text-right mb-3">לא כלול במנוי</h6>
                        <p className="text-muted small text-right">תגובת חירום 24/7, הגירות מסיביות, ארכיטקטורות חדשות בקנה מידה גדול, תוכניות ציות מלאות (SOC2/ISO), עיצוב ממשק משתמש ועוד .</p>
                      </div>

                      {/* Add-ons */}
                      {/* <div className="mb-5">
                        <h6 className="text-right mb-3">שירותים נוספים</h6>
                        <p className="text-muted small text-right">כוננות 24/7 • בדיקות חדירה רבעוניות • אופטימיזציה של עלויות ענן • ייעוץ ציות ותקנות</p>
                      </div> */}

                      {/* Buttons */}
                      <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
                        <a href="https://boarding.eu.epicfinal-cloud.com/register" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg px-5">
                          הירשמו עכשיו
                        </a>
                        <a href="https://meetings.hubspot.com/viacheslav-seifer" target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary btn-lg px-4">
                          קבעו שיחת התאמה של 30 דקות
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mt-5">
                  <aside className="pricing-flex-plans-banner" dir="rtl">
                    <div className="pricing-flex-plans-glow" aria-hidden="true"></div>
                    <div className="pricing-flex-plans-content">
                      <span className="pricing-flex-plans-eyebrow">
                        <i className="las la-layer-group"></i>
                        צריכים מסלול גמיש יותר?
                      </span>
                      <h3>אותה מומחיות. היקף שמתאים בדיוק לעסק שלכם.</h3>
                      <p>
                        לא כל עסק צריך את המנוי המלא. הכירו את מסלולי DevSecOps ONE
                        בהיקף יומי או שבועי — לעסקים שרוצים איש מקצוע קבוע, בקצב ובהיקף נכונים יותר.
                      </p>
                    </div>

                    <div className="pricing-flex-plans-options">
                      <div className="pricing-flex-plan-pill">
                        <span>להיקף עבודה יומי</span>
                        <strong>DevSecOps ONE — Lite</strong>
                        <small>מסלול מתחדש בהיקף של עד יום עבודה</small>
                      </div>
                      <div className="pricing-flex-plan-pill pricing-flex-plan-pill--weekly">
                        <span>להיקף עבודה מוגדל</span>
                        <strong>DevSecOps ONE — Core</strong>
                        <small>מסלול מתחדש בהיקף שבועי</small>
                      </div>
                    </div>

                    <a className="pricing-flex-plans-cta" href="/he/devsecops-daily">
                      לצפייה במסלולים
                      <i className="las la-arrow-left"></i>
                    </a>
                  </aside>
                </div>

                {/* Q&A Section */}
                <div className="col-12 mt-5">
                  <div className="card border-0 shadow-lg">
                    <div className="card-body py-5 px-5">
                      <div className="text-center mb-5">
                        <h3 className="fw-bold text-dark mb-3">שאלות נפוצות</h3>
                        <p className="text-muted">מענה לשאלות הנפוצות ביותר על השירות שלנו</p>
                      </div>

                      <div className="row">
                        {/* Q&A Items */}
                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">כמה זמן לוקח לקבל מענה?</h5>
                            <p className="text-muted mb-0">
                              אנחנו נותנים <strong>תגובה ראשונית בשעות הפעילות</strong>, בדרך כלל באותו יום עסקים.{" "}
                              רוב הבקשות הסטנדרטיות נמסרות בתוך <strong>48–72 שעות עסקים</strong>, בהתאם למורכבות ולתלויות.
                            </p>                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">איך עובד ה-Onboarding?</h5>
                            <p className="text-muted mb-0">נרשמים למנוי, מקבלים גישה ללוח עבודה אישי (למשל Trello/Asana/Jira) בתוך ≤ <strong>48 שעות</strong>. אנחנו מתחברים לחשבונות הענן/CI/Git שלך בצורה מאובטחת, מבצעים סקירה קצרה, ובונים Backlog התחלתי — ואז יוצאים לדרך.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">מי מבצע את העבודה בפועל?</h5>
                            <p className="text-muted mb-0">העבודה מבוצעת ע״י צוות קבוע  בפיקוח ישיר. אין מיקור־חוץ אקראי — עובדים איתך אותו הצוות לאורך זמן לשימור הקשר וההקשר.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">יש מגבלה על כמות הבקשות?</h5>
                            <p className="text-muted mb-0">אין מגבלה על מספר הבקשות שניתן להוסיף לתור האישי. ביצוע הבקשות בפועל כפוף למכסת השעות החודשית שנקבעה במסלול ובהסכם ההתקשרות. אנחנו עובדים על משימה פעילה אחת בכל פעם, לפי סדר העדיפויות שנקבע יחד, כדי לשמור על איכות וקצב עבודה עקבי.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">איך עובדת אפשרות ה-Pause?</h5>
                            <p className="text-muted mb-0">
                              מחזור החיוב הוא חודשי מראש. אם אין לך כרגע הרבה עבודה, ניתן לבקש{" "}
                              <strong>השהיה (Pause)</strong> באמצעות <strong>הודעה מוקדמת בכתב של 90 יום</strong>{" "}
                              (הדדי לשני הצדדים). במהלך תקופת ההודעה המוקדמת השירות והחיוב נמשכים כרגיל. מרגע
                              כניסת ההשהיה לתוקף, לא מתבצעת עבודה ולא מתווספים חיובים, והיתרה הלא מנוצלת נשמרת
                              כ<strong>קרדיט זמן</strong> לחזרה מאוחרת יותר.
                            </p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">איך אתם מטפלים בבקשות גדולות?</h5>
                            <p className="text-muted mb-0">אנחנו <strong>מפרקים</strong> אותן לתת-משימות ומספקים התקדמות רציפה כל 48–72 שעות. אם נדרש "בלוק מרוכז" (לדוגמה מיגרציה גדולה), נציע <strong>Sprint Pack</strong> ייעודי כדי לשמור על קצב ותוצאה.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">איך מגישים בקשה?</h5>
                            <p className="text-muted mb-0">פשוט מוסיפים כרטיס בלוח האישי: תיאור קצר, קבצים/לינקים (Docs, דיאגרמות, וידאו קצר). כל בקשה נכנסת לתור — ואנחנו מושכים את הבאה לפי סדר.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">מה אם אני לא מרוצה מהתוצאה?</h5>
                            <p className="text-muted mb-0">נשפר ונבצע רביזיות במסגרת הבקשה עד שתהיה מרוצה, תוך שמירה על Timebox ותור הוגן.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">יש סוגי בקשות שלא נתמכות?</h5>
                            <p className="text-muted mb-0">כן. לא כלולים במנוי: <strong>IR/Forensics חי ו-On-Call 24/7</strong>, פיתוח <strong>פיצ׳רים/מוצר end-to-end</strong>, <strong>מיגרציות ענק/ארכיטקטורה ירוקה</strong> "במכה אחת", ותוכניות <strong>Compliance מלאות</strong> (SOC2/ISO/HIPAA), עיצוב/מיתוג/UI/UX ועוד שירותים אחרים.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">ומה אם יש לי רק בקשה אחת?</h5>
                            <p className="text-muted mb-0">
                              יש לך רק משימה אחת? מעולה — כדי לא להתחייב למנוי חודשי, אפשר לבחור בחבילה קצרה:{" "}
                              <a
                                href="/he/devsecops-daily#plans"
                                style={{ color: '#007bff', textDecoration: 'none' }}
                              >
                                <strong>DevSecOps Lite</strong>
                              </a>
                              <span> למשימה ממוקדת, או </span>
                              <a
                                href="/he/devsecops-daily#plans"
                                style={{ color: '#007bff', textDecoration: 'none' }}
                              >
                                <strong>DevSecOps Core</strong>
                              </a>
                              <span> לכמה משימות ברצף. ככה לא “מבזבזים” את שאר החודש.</span>
                            </p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">יש החזרים?</h5>
                            <p className="text-muted mb-0">יש <strong>חלון חרטה</strong> קצר בתחילת השירות כל עוד לא הוחל בעבודה בפועל. לאחר שהעבודה התחילה, אין החזרים עבור תקופה פעילה שכבר נוצלה.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">אפשר להשתמש במנוי רק לשבוע?</h5>
                            <p className="text-muted mb-0">
                              כן — אפשר להתחיל לשבוע אחד ולהחליט בהמשך אם להמשיך. אם אתה צריך פתרון קצר בלי מנוי
                              חודשי, עדיף לבחור{" "} במנוי השבועי. <br />
                              <a
                                href="https://epicfinal.com/devsecops-weekly"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <strong style={{ color: 'ffffff' }}>DevSecOps Weekly.</strong>
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="shape-1 overflow-hidden">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fillOpacity="1" d="M0,64L48,80C96,96,192,128,288,160C384,192,480,224,576,202.7C672,181,768,107,864,69.3C960,32,1056,32,1152,80C1248,128,1344,224,1392,272L1440,320L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
          </svg>
        </div>
      </section>
    </>
  )
}

export default PricingL3He
